import { FieldAttributes, Field as FormikField, useField } from 'formik';
import React from 'react';

function Field(props: FieldAttributes<any>) {
    const [field, meta] = useField(props);

    const getValidationClasses = () => {
        let className = props.className ? `${props.className} ` : '';

        if (meta.error) {
            className += 'is-invalid ';
        }

        return className;
    };

    return <FormikField {...field} {...props} className={getValidationClasses()} />;
}

export { Field };
